// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2GTEI","location":"Header_location__1ykxa"};